import logo from '../../../../images/logo.png';
import ImageWithSkeleton from '../../../components/Custom/Common/ImageWithSkeleton';
import { getHeroStyle, resolvePublicAssetUrl } from './publicBrand';

/** Topo com banner, logo e título das telas públicas do cliente (Meus agendamentos, Planos). */
const PublicHero = ({ companyInfo, title, subtitle }) => (
    <div className="booking-hero" style={getHeroStyle(companyInfo)}>
        {companyInfo?.bannerUrl && (
            <div
                className="booking-hero-banner-layer"
                aria-hidden="true"
                style={{
                    backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.55), rgba(15, 23, 42, 0.55)), url(${resolvePublicAssetUrl(companyInfo.bannerUrl)})`,
                    backgroundPosition: `${companyInfo?.bannerPositionX ?? 50}% ${companyInfo?.bannerPositionY ?? 50}%`,
                    backgroundSize: 'cover',
                    transform: `scale(${(companyInfo?.bannerZoom ?? 100) / 100})`,
                    transformOrigin: `${companyInfo?.bannerPositionX ?? 50}% ${companyInfo?.bannerPositionY ?? 50}%`,
                }}
            />
        )}
        <div className="booking-hero-content booking-hero-content--compact">
            <div className="booking-hero-brand">
                {companyInfo?.showLogoOnBookingPage !== false && (
                    <div className="booking-hero-logo">
                        {companyInfo?.logoUrl ? (
                            <ImageWithSkeleton src={resolvePublicAssetUrl(companyInfo.logoUrl)} alt={companyInfo.name} fill onDark />
                        ) : <img src={logo} alt="Colmeia Barber" />}
                    </div>
                )}
                {companyInfo?.showCompanyNameOnBookingPage !== false && <span className="booking-hero-brand__name">{companyInfo?.name}</span>}
            </div>
            <div className="booking-hero-copy">
                <h1 className="booking-hero-name">{title}</h1>
                <p className="booking-hero-sub">{subtitle}</p>
            </div>
        </div>
    </div>
);

export default PublicHero;
